var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGmeetBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2016_18344",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2016_18344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33293 16.6665C2.87459 16.6665 2.48237 16.5034 2.15626 16.1773C1.82959 15.8506 1.66626 15.4581 1.66626 14.9998V4.9998C1.66626 4.54146 1.82959 4.14924 2.15626 3.82313C2.48237 3.49646 2.87459 3.33313 3.33293 3.33313H13.3329C13.7913 3.33313 14.1838 3.49646 14.5104 3.82313C14.8365 4.14924 14.9996 4.54146 14.9996 4.9998V8.7498L18.3329 5.41646V14.5831L14.9996 11.2498V14.9998C14.9996 15.4581 14.8365 15.8506 14.5104 16.1773C14.1838 16.5034 13.7913 16.6665 13.3329 16.6665H3.33293ZM3.33293 14.9998H13.3329V4.9998H3.33293V14.9998Z",
    fill: "#366EE3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmeetBlue);
export default __webpack_public_path__ + "static/media/gmeet_blue.40c55e702574a09e16c1ebcdd1da1c23.svg";
export { ForwardRef as ReactComponent };